import { RefinementList } from "react-instantsearch";
import { cn } from "@repo/ui/lib/utils";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";
import { useState } from "react";
import { ScrollArea } from "@repo/ui/components/ui/scroll-area";

export default function AlgoliaRefinementList({
  attribute,
  title,
  customCheckbox = false,
  searchable = false,
  sticky = false,
  placeholder = "",
}: {
  attribute: string;
  title: string;
  searchable?: boolean;
  customCheckbox?: boolean;
  sticky?: boolean;
  placeholder?: string;
}) {
  const [open, setOpen] = useState(false);
  const handleOpen = (data: string) => setOpen(!!data);
  return (
    <Accordion
      type="single"
      collapsible
      onValueChange={handleOpen}
      className={cn({
        "max-md:sticky max-md:w-full max-md:top-[70px] max-md:z-10 max-md:bg-primary-white":
          sticky && open,
      })}
    >
      <AccordionItem value="item-1">
        <div className="py-[16px]">
          <AccordionTrigger className="max-md:text-base font-medium py-0 data-[state=open]:text-primary-magenta">
            {title}
          </AccordionTrigger>
          <AccordionContent className="mt-[20px] pb-0">
            <ScrollArea className="h-[400px]">
              <RefinementList
                // sortBy={["name:asc"]}
                searchable={searchable}
                limit={100}
                searchablePlaceholder={placeholder}
                classNames={{
                  list: cn({
                    "grid grid-cols-3 gap-4 items-stretch pr-4": customCheckbox,
                  }),
                  selectedItem: cn("font-bold", {
                    "*:font-bold *:border-2 *:border-primary-magenta":
                      customCheckbox,
                  }),
                  label: cn(
                    "flex items-center gap-[16px] text-[14px] text-secondary-black mb-2",
                    "[&_mark]:bg-primary-magenta",
                    "[&_mark]:text-primary-white",
                    "[&_mark]:font-bold",
                    {
                      "border border-secondary-gray1 p-2 cursor-pointer flex justify-center mb-0 h-full":
                        customCheckbox,
                    },
                  ),
                  checkbox: cn(
                    "relative appearance-none h-[24px] max-w-[24px] min-w-[24px] rounded-[5px] border-[2px] border-secondary-black border-opacity-50 bg-[#F8F6F7]",
                    "checked:before:content-[''] checked:before:flex checked:before:justify-center checked:before:items-center checked:before:h-[8px] checked:before:w-[8px]",
                    "checked:before:rounded-full checked:before:bg-primary-magenta checked:before:absolute checked:before:top-[6px] checked:before:left-[6px]",
                    { hidden: customCheckbox },
                  ),
                  count: "hidden",
                  searchBox: cn(
                    "mb-4 md:w-[300px]",
                    "[&_form]:flex",
                    "[&_form]:gap-2",
                    "[&_form]:w-auto",
                    "[&_form]:py-2",
                    "[&_form]:px-4",
                    "[&_form]:flex-row-reverse",
                    "[&_form]:justify-end",
                    "[&_[type='reset']]:-order-1",
                    "[&_form]:bg-secondary-gray2",
                    "[&_form]:rounded-full",
                    "[&_input]:text-primary-black",
                    "[&_input]:h-[32px]",
                    "[&_input]:flex-1",
                    "[&_input]:bg-secondary-gray2",
                    "[&_input]:text-[14px]",
                    "[&_input]:ring-offset-background",
                    "[&_input:focus-visible]:outline-none",
                    "[&_input:focus-visible]:ring-none",
                    "[&_input:disabled]:cursor-not-allowed",
                    "[&_input:disabled]:opacity-50",
                    "[&_input]:placeholder:text-primary-black",
                    "[&_svg]:fill-primary-magenta",
                    "[&_svg]:stroke-primary-magenta",
                    "[&_svg]:h-[24px]",
                    "[&_svg]:w-[24px]",
                    "[&_[type='reset']]:hidden",
                  ),
                  // count:
                  //   "bg-primary-magenta rounded-full w-[20px] h-[20px] flex justify-center items-center text-primary-white font-bold",
                }}
                attribute={attribute}
              />
            </ScrollArea>
          </AccordionContent>
        </div>
      </AccordionItem>
    </Accordion>
  );
}
